export const BRAND = {
  name: "Vietnam Aquatics",
  tagline: "Dive into your performance.",
  poweredBy: "Powered by SportsLink",
  description:
    "The official swimmer portal of the Vietnam Aquatics federation. Track results, register for meets, and stay in sync with your club, powered by SportsLink.",
  ctaPrimary: "Register",
  ctaSecondary: "Sign In",
  ctaWaitlist: "Join the Waitlist",
  contactEmail: "hello@swimvietnam.app",
  copyright: "© 2026 Vietnam Aquatics. Powered by SportsLink. All rights reserved.",
}

export const NAV_LINKS = [
  { href: "#how-it-works", label: "How it works" },
  { href: "#features", label: "Features" },
  { href: "#clubs", label: "Clubs & coaches" },
  { href: "#faq", label: "FAQ" },
]
